import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import "../../assets/styles/pages.css";
import example from "../../assets/files/mau_code.xlsx";
import TableCodes from "../table/tableCodes";
import PropTypes from "prop-types";
import LoadingButton from "@mui/lab/LoadingButton";
import TablePagination from "@mui/material/TablePagination";
import Header from "../../layout/Header";
import Sidebar from "../sidebar/Sidebar";
import Swal from "sweetalert2";
import { read, utils } from "xlsx";
import { Autocomplete, Box, Button, IconButton, Input, TextField, Typography } from "@mui/material";
import { deleteCode, generateCode_download, get_info_promo_code, uploadCode } from "../../services/api.service";
import { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { ArrowDropDown, ArrowDropUp, FileDownload, FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage, Shuffle } from "@mui/icons-material";

import { check_role } from "../../controllers/helps.controller";
import { findCode_download, findCode_paging } from "../../services/promocode.service";
import moment from "moment";
import { useIntl } from 'react-intl';

const GenerateCode = () => {
  const intl = useIntl();

  // Define arrays first
  const arrTypePoint = [
    { value: "number_static", label: intl.formatMessage({ id: 'select.typePoint.fixed' }) },
    { value: "number_range", label: intl.formatMessage({ id: 'select.typePoint.fromTo' }) },
    { value: "number_or", label: intl.formatMessage({ id: 'select.typePoint.either' }) }
  ];

  const arrTypeMKM = [
    { value: "one_per_day", label: intl.formatMessage({ id: 'codeFrequency.onePerDay' }) },
    { value: "one_per_3day", label: intl.formatMessage({ id: 'codeFrequency.onePerThreeDays' }) },
    { value: "one_per_week", label: intl.formatMessage({ id: 'codeFrequency.onePerWeek' }) },
    { value: "one_per_month", label: intl.formatMessage({ id: 'codeFrequency.onePerMonth' }) },
    { value: "no_limit", label: intl.formatMessage({ id: 'codeFrequency.noLimit' }) },
    { value: "one_only", label: intl.formatMessage({ id: 'codeFrequency.oneOnly' }) },
  ];

  const arrDepositeV2 = [
    { value: "all", label: intl.formatMessage({ id: 'deposit.all' }) },
    { value: "more_then", label: intl.formatMessage({ id: 'deposit.moreThan' }) },
    { value: "less_then", label: intl.formatMessage({ id: 'deposit.lessThan' }) },
  ];

  const arrWithdrawV2 = [
    { value: "all", label: intl.formatMessage({ id: 'withdraw.all' }) },
    { value: "more_then", label: intl.formatMessage({ id: 'withdraw.moreThan' }) },
    { value: "less_then", label: intl.formatMessage({ id: 'withdraw.lessThan' }) },
  ];

  const arrUsedMKM = [
    { value: "code_non", label: intl.formatMessage({ id: 'codeUsage.unused' }) },
    { value: "code_used", label: intl.formatMessage({ id: 'codeUsage.used' }) },
  ];

  const arrStatusCode = [
    { value: "all", label: intl.formatMessage({ id: 'codeStatus.all' }) },
    { value: "unused", label: intl.formatMessage({ id: 'codeStatus.unused' }) },
    { value: "used", label: intl.formatMessage({ id: 'codeStatus.used' }) },
    { value: "expired", label: intl.formatMessage({ id: 'codeStatus.expired' }) },
  ];

  const arrTypePromocode = [
    { value: "approximate", label: intl.formatMessage({ id: 'promocodeType.approximate' }) },
    { value: "exact", label: intl.formatMessage({ id: 'promocodeType.exact' }) },
  ];

  const arrTypeChar = [
    { value: "A-Za-z0-9", label: intl.formatMessage({ id: 'characterType.alphanumeric' }) },
    { value: "A-Z0-9", label: intl.formatMessage({ id: 'characterType.uppercaseAlphanumeric' }) },
    { value: "a-z0-9", label: intl.formatMessage({ id: 'characterType.lowercaseAlphanumeric' }) },
  ];

  const arrCheckIPFP = [
    { value: "nocheck", label: intl.formatMessage({ id: 'ipfpCheck.noCheck' }) },
    { value: "check", label: intl.formatMessage({ id: 'ipfpCheck.check' }) },
  ];

  const arrInternalMess = [
    { value: "nosend", label: intl.formatMessage({ id: 'internalMessage.noSend' }) },
    { value: "send", label: intl.formatMessage({ id: 'internalMessage.send' }) },
  ];

  const arrGenerateQr = [
    { value: "nogenerate", label: intl.formatMessage({ id: 'qrCode.noGenerate' }) },
    { value: "generate", label: intl.formatMessage({ id: 'qrCode.generate' }) },
  ];

  const arrCode_send = [
    { value: "free", label: intl.formatMessage({ id: 'codeSend.freeCode' }) },
    { value: "seo", label: intl.formatMessage({ id: 'codeSend.seoCode' }) },
    { value: "phone", label: intl.formatMessage({ id: 'codeSend.phoneCode' }) },
  ];

  const find_arrCode_send = [
    { value: "", label: intl.formatMessage({ id: 'codeSend.all' }) },
    { value: "free", label: intl.formatMessage({ id: 'codeSend.freeCode' }) },
    { value: "seo", label: intl.formatMessage({ id: 'codeSend.seoCode' }) },
    { value: "phone", label: intl.formatMessage({ id: 'codeSend.phoneCode' }) },
  ];

  // Now, state declarations and function calls
  const [navstate, setNavstate] = useState(localStorage.getItem("nav-state") ?? true);

  // Ensure this is below array definitions
  const role_superadmin = check_role("superadmin");

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    let handle = async () => {
      if (!localStorage.getItem("username-redeem")) {
        window.location.replace("/login");
      }
    };
    handle();
  }, []);
  // generate code
  const [generate, setGenerate] = useState(false);
  const [type_code, setType_code] = useState(arrTypeMKM[0]);
  const [used_code, setUsed_code] = useState(arrUsedMKM[0]);
  const [used_time, setUsed_time] = useState(new Date());
  const [releaseCode, setReleaseCode] = useState("");
  const [countCode, setCountCode] = useState(1);
  const [lengthCode, setLengthCode] = useState(1);
  const [promo_id, setPromo_id] = useState("");
  const [round, setRound] = useState(1);
  const [typePoint, setTypePoint] = useState(arrTypePoint[0]);
  const [staticPoint, setStaticPoint] = useState(1);
  const [startOfPoint, setStartOfPoint] = useState(1);
  const [endOfPoint, setEndOfPoint] = useState(1);
  const [fixed, setFixed] = useState(0);
  const [startOf_time, setStartOf_time] = useState(new Date());//changecode
  console.log(startOf_time);
  const [endOf_time, setEndOf_time] = useState(new Date());//changecode
  //
  const [showmore, setShowmore] = useState(false);
  //
  const [deposite, setDeposite] = useState(arrDepositeV2[0]);
  const [withdraw, setWithdraw] = useState(arrWithdrawV2[0]);
  const [depositeCount, setDepositeCount] = useState();
  const [depositeTotal, setDepositeTotal] = useState();
  const [withdrawCount, setWithdrawCount] = useState();
  const [withdrawTotal, setWithdrawTotal] = useState();
  // find code
  const [find_releaseCode, setFind_releaseCode] = useState("");
  const [find_promo_id, setFind_promo_id] = useState("");
  const [find_promo_code, setFind_promo_code] = useState("");
  const [find_user_used, setFind_user_used] = useState("");
  const [find_ip, setFind_ip] = useState("");
  const [find_status, setFind_status] = useState(arrStatusCode[0]);
  const [find_endOf_time, setFind_endOf_time] = useState();
  const [find_code_send, setFind_code_send] = useState(find_arrCode_send[0]);
  //
  const [find_typePromo_code, setFind_typePromo_code] = useState(arrTypePromocode[0]);
  const [exporting, setExporting] = useState(false);
  //
  const [checkIPFP, setCheckIPFP] = useState(arrCheckIPFP[0]);
  const [typeChar, setTypeChar] = useState(arrTypeChar[0]);
  const [internalMess, setInternalMess] = useState(arrInternalMess[0]);
  //
  const [code_send, setCode_send] = useState(arrCode_send[0]);
  const [receiveTotal, setReceiveTotal] = useState(1);
  const [generateQr, setGenerateQr] = useState(arrGenerateQr[0]);
  useEffect(() => {
    let handle = async () => {
      if (!localStorage.getItem("username-redeem")) {
        window.location.replace("/login");
      }
      try {
        let codeResult = await get_info_promo_code();
        if (codeResult && codeResult[0]) {
          document.getElementById("count-bill").innerHTML = codeResult[0].code_released?.toLocaleString("en-US") || "0";
          document.getElementById("balance").innerHTML = codeResult[0].code_create?.toLocaleString("en-US") || "0";
          document.getElementById("amount-currency").innerHTML = ((codeResult[0].amount_issued || 0) * 1000).toLocaleString("en-US");
          document.getElementById("code_fake").innerHTML = codeResult[0].code_fake?.toLocaleString("en-US") || "0";
        }
      } catch (error) {
        console.error("Error fetching promo code info:", error);
        // Set default values if there's an error
        document.getElementById("count-bill").innerHTML = "0";
        document.getElementById("balance").innerHTML = "0";
        document.getElementById("amount-currency").innerHTML = "0";
        document.getElementById("code_fake").innerHTML = "0";
      }
    };
    handle();

    const username = localStorage.getItem("username-redeem")?.toLowerCase() || "";
    document.getElementsByClassName("user-text")[0].innerHTML = username;
    document.getElementsByClassName("transfer-machine")[0].innerHTML = check_role("superadmin")
      ? intl.formatMessage({ id: 'page.managePromoCode' })
      : intl.formatMessage({ id: 'page.checkPromoCode' });
  }, [intl]);
  useEffect(() => {
    let initData = async () => {
      Swal.fire({
        allowOutsideClick: false,
        background: "none",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      let find_endOf_time_tmp = 0;
      if (find_endOf_time) {
        find_endOf_time_tmp = new Date(find_endOf_time).getTime() - new Date().getTimezoneOffset() * 60000 - 420 * 60000;
      }

      if (role_superadmin) {
        const data = await findCode_paging(
          find_endOf_time_tmp,
          find_promo_code,
          find_typePromo_code,
          find_releaseCode,
          find_promo_id,
          find_user_used,
          find_ip,
          find_status?.value,
          find_code_send?.value,
          page,
          rowsPerPage
        );

        if (data?.statusCode === 404) {
          setRows([]);
          await Swal.fire({
            icon: "error",
            title: "Không tìm thấy code",
          });
        } else {
          Swal.close();
          setRows(data?.detail);
          setTotal(data?.total);
        }
      }
      Swal.close();
    };
    initData();
  }, [
    page,
    rowsPerPage,
    find_code_send?.value,
    find_endOf_time,
    find_ip,
    find_promo_code,
    find_promo_id,
    find_releaseCode,
    find_status?.value,
    find_typePromo_code,
    find_user_used,
    role_superadmin
  ]);
  const handelFind_code_paging = async () => {
    Swal.fire({
      allowOutsideClick: false,
      background: "none",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    let find_endOf_time_tmp = 0;
    if (find_endOf_time) {
      find_endOf_time_tmp = new Date(find_endOf_time).getTime() - new Date().getTimezoneOffset() * 60000 - 420 * 60000;
    }

    if (role_superadmin) {
      const data = await findCode_paging(
        find_endOf_time_tmp,
        find_promo_code,
        find_typePromo_code,
        find_releaseCode,
        find_promo_id,
        find_user_used,
        find_ip,
        find_status?.value,
        find_code_send?.value,
        page,
        rowsPerPage
      );
      if (data?.statusCode === 404) {
        Swal.fire({
          icon: "error",
          title: "Không tìm thấy code",
        });
        setRows([]);
        setTotal(0);
      } else {
        setRows(data?.detail);
        setTotal(data?.total);

        Swal.close();
      }
    } else if (!find_promo_code && !find_user_used) {
      Swal.fire({
        icon: "error",
        title: "Hãy điền mã code để tìm kiếm",
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    } else {
      const data = await findCode_paging(
        find_endOf_time_tmp,
        find_promo_code,
        find_typePromo_code,
        undefined,
        undefined,
        find_user_used,
        undefined,
        undefined,
        undefined,
        0,
        10
      );
      if (data?.statusCode === 404) {
        Swal.fire({
          icon: "error",
          title: "Không tìm thấy code",
        });
        setRows([]);
        setTotal(0);
      } else {
        setRows(data?.detail);
        setTotal(data?.total);
        Swal.close();
      }
    }
  };

  
  // Const find code
  const Generate_Download = async () => {
    if (generate) return;
    setGenerate(true);

    //try catch để đảm bảo trong mọi trường hợp biến state generate sẽ được trả về false để có thể tạo code lại
    try {
      if (
        !releaseCode ||
        !countCode ||
        !used_code || // - used_time
        !lengthCode ||
        !promo_id ||
        !round ||
        !typePoint || // - !staticPoint || !startOfPoint && !endOfPoint
        !startOf_time ||
        !endOf_time ||
        !type_code ||
        !deposite ||
        !withdraw ||
        !typeChar ||
        !checkIPFP ||
        !internalMess ||
        !code_send ||
        !receiveTotal ||
        !generateQr
      ) {
        return Swal.fire(
          intl.formatMessage({ id: 'alert.failed' }), 
          intl.formatMessage({ id: 'alert.fillAllFields' }), 
          "error"
        );
      } else {
        // check used_code
        if (used_code?.value === "code_used" && !used_time) {
          return Swal.fire(
            intl.formatMessage({ id: 'alert.failed' }),
            intl.formatMessage({ id: 'alert.missingUsedTime' }),
            "error"
          );
        }
        // check typePoint
        if (typePoint?.value === "number_static" && (!staticPoint || staticPoint === 0)) {
          return Swal.fire(
            intl.formatMessage({ id: 'alert.failed' }),
            intl.formatMessage({ id: 'alert.missingPoints' }),
            "error"
          );
        }
        if (
          (typePoint?.value === "number_range" || typePoint?.value === "number_or") &&
          (!startOfPoint || !endOfPoint || startOfPoint === 0 || endOfPoint === 0)
        ) {
          return Swal.fire(
            intl.formatMessage({ id: 'alert.failed' }),
            intl.formatMessage({ id: 'alert.missingPoints' }),
            "error"
          );
        }
        // check deposite
        if ((deposite?.value === "more_then" || deposite?.value === "less_then") && (!depositeCount || !depositeTotal)) {
          return Swal.fire(
            intl.formatMessage({ id: 'alert.failed' }),
            intl.formatMessage({ id: 'alert.missingDeposit' }), 
            "error"
          );
        }
        // check withdraw
        if ((withdraw?.value === "more_then" || withdraw?.value === "less_then") && (!withdrawCount || !withdrawTotal)) {
          return Swal.fire(
            intl.formatMessage({ id: 'alert.failed' }),
            intl.formatMessage({ id: 'alert.missingWithdraw' }),
            "error"
          );
        }
        // check receive
        if (receiveTotal < 1) {
          return Swal.fire(
            intl.formatMessage({ id: 'alert.failed' }),
            intl.formatMessage({ id: 'alert.invalidReceiveTimes' }),
            "error"
          );
        }

        if (generateQr?.value === "generate" && parseInt(countCode) > 1500) {
          return Swal.fire(
            intl.formatMessage({ id: 'alert.failed' }),
            intl.formatMessage({ id: 'alert.qrLimitExceeded' }),
            "error"
          );
        }

        let used_time_tmp = new Date(used_time).getTime() - new Date().getTimezoneOffset() * 60000 - 420 * 60000;
        let startOf_time_tmp = new Date(startOf_time).getTime() - new Date().getTimezoneOffset() * 60000 - 420 * 60000;
        let endOf_time_tmp = new Date(endOf_time).getTime() - new Date().getTimezoneOffset() * 60000 - 420 * 60000;
        if (endOf_time_tmp <= startOf_time_tmp) {
          return Swal.fire(
            intl.formatMessage({ id: 'alert.failed' }),
            intl.formatMessage({ id: 'alert.invalidTimeRange' }),
            "error"
          );
        }
        Swal.fire({
          text: intl.formatMessage({ id: 'alert.initializingData' }),
          width: 250,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        let data = {
          site: localStorage.getItem("site-redeem"),
          countCode: countCode,
          endOfPoint: endOfPoint,
          endOf_time: endOf_time_tmp,
          lengthCode: lengthCode,
          promo_id: promo_id,
          releaseCode: releaseCode,
          round: round,
          startOfPoint: startOfPoint,
          startOf_time: startOf_time_tmp,
          staticPoint: staticPoint,
          typePoint: typePoint?.value,
          deposite: deposite?.value,
          depositeCount: depositeCount,
          depositeTotal: depositeTotal,
          withdraw: withdraw?.value,
          withdrawCount: withdrawCount,
          withdrawTotal: withdrawTotal,
          type_code: type_code?.value,
          used_code: used_code?.value,
          used_time: used_time_tmp,
          typeChar: typeChar?.value,
          checkIPFP: checkIPFP?.value,
          internalMess: internalMess?.value,
          code_send: code_send?.value,
          receiveTotal: receiveTotal,
          generateQr: generateQr?.value,
          fixed: fixed,
        };
        /* A B C D E F G H I J K L M N O P Q R S T U V W X Y Z */
        await generateCode_download(data);
        handelFind_code_paging()
      }
    } catch (error) {
      console.error('có lỗi xảy ra trong quá trình thực thi fn generate_download:', error);
    } finally {
      setGenerate(false);
    }
  };
  const reset_Download = async () => {
    setGenerate("");
    setType_code("");
    setUsed_code("");
    setUsed_time("");
    setReleaseCode("");
    setCountCode("");
    setLengthCode("");
    setPromo_id("");
    setRound("");
    setTypePoint("");
    setStaticPoint("");
    setStartOfPoint("");
    setEndOfPoint("");
    setStartOf_time("");
    setEndOf_time("");
    setDeposite("");
    setWithdraw("");
    setDepositeCount("");
    setDepositeTotal("");
    setWithdrawCount("");
    setWithdrawTotal("");
    setExporting("");
    setCheckIPFP("");
    setTypeChar("");
    setInternalMess("");
    setCode_send("");
    setReceiveTotal("");
    setGenerateQr("");
  };
  const handelExport_code = async () => {
    setExporting(true);
    await Swal.fire({
      title: intl.formatMessage({ id: 'alert.exportExcel' }),
      html: `
        <Box class="download-code-btn-cont">
          <button class="download-code-modal" btn-id="unused">
            <i class="fa-solid fa-list-check"></i>
            ${intl.formatMessage({ id: 'alert.unusedValidCodes' })}
          </button>
          <button class="download-code-modal" btn-id="used">
          <i class="fa-solid fa-file-circle-check"></i>
            ${intl.formatMessage({ id: 'alert.usedCodes' })}
          </button>
          <button class="download-code-modal" btn-id="exp-code">
            <i class="fa-regular fa-file-excel"></i>
            ${intl.formatMessage({ id: 'alert.expiredCodes' })}
          </button>
          <button class="download-code-modal" btn-id="code-find-filter">
            <i class="fa-solid fa-search"></i>
            ${intl.formatMessage({ id: 'alert.searchFilteredCodes' })}
          </button>
        </Box>
      `,
      showConfirmButton: false, 
      showDenyButton: true,
      denyButtonText: intl.formatMessage({ id: 'button.cancel' }),
      allowOutsideClick: false,
      didOpen: async () => {
        document.querySelectorAll(".download-code-modal").forEach(async (el) => {
          el.addEventListener("click", async () => {
            Swal.fire({
              text: intl.formatMessage({ id: 'alert.loadingData' }),
              width: 250,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              },
            });
            let find_endOf_time_tmp = 0;
            if (find_endOf_time) {
              find_endOf_time_tmp = new Date(find_endOf_time).getTime() - new Date().getTimezoneOffset() * 60000 - 420 * 60000;
            }
            const type = el.getAttribute("btn-id");
            let attach_qr = "noattach";
            if (type === "code-find-filter" || type === "unused") {
              const { value: attach } = await Swal.fire({
                title: intl.formatMessage({ id: 'alert.exportQrCode' }),
                input: "select",
                inputOptions: {
                  noattach: intl.formatMessage({ id: 'alert.noAttach' }),
                  attach: intl.formatMessage({ id: 'alert.attach' }),
                },
                inputPlaceholder: intl.formatMessage({ id: 'alert.exportQrCode' }),
                showCancelButton: true,
                inputValidator: (value) => {
                  return new Promise((resolve) => {
                    if (value !== "") {
                      resolve();
                    } else {
                      resolve(intl.formatMessage({ id: 'alert.choosePlease' }));
                    }
                  });
                },
                didOpen: () => {
                  Swal.hideLoading();
                },
              });
              attach_qr = attach;
            }
            if (attach_qr) {
              let resultstatus = await findCode_download({
                type: type,
                endOf_time: find_endOf_time_tmp,
                promo_code: find_promo_code,
                releaseCode: find_releaseCode,
                promo_id: find_promo_id,
                user_used: find_user_used,
                ip: find_ip,
                status: find_status?.value,
                code_send: find_code_send?.value,
                attach_qr: attach_qr,
              });
              Swal.fire({
                icon: resultstatus === 200 ? "success" : resultstatus === 404 ? "warning" : "error",
                title: resultstatus === 200 ? intl.formatMessage({ id: 'alert.downloadSuccess' }) : resultstatus === 404 ? intl.formatMessage({ id: 'alert.noData' }) : intl.formatMessage({ id: 'alert.fileDownloadError' }),
              });
            }
            setExporting(false);
          });
        });
      },
    });
    setExporting(false);
  };
  const handelUplpadFile_code_Yakun = async () => {
    let { value: file_xlsx } = await Swal.fire({
      title: intl.formatMessage({ id: 'alert.chooseFile' }),
      html: `<p class='luu-y'>${intl.formatMessage({ id: 'alert.noteCorrectFormat' })}</p> <p class='dinh-dang-time'>${intl.formatMessage({ id: 'alert.timeFormat' })} <span class='time-format'>\`yyyy/mm/dd H:mm:ss\`</span></p><p class='gio-vn'>${intl.formatMessage({ id: 'alert.vnTime' })}</p>`,
      input: "file",
      showCancelButton: true,
      cancelButtonText: intl.formatMessage({ id: 'button.cancel' }),
      confirmButtonText: intl.formatMessage({ id: 'button.uploadList' }),
      inputAttributes: {
        accept: "xlsx/xls",
        "aria-label": intl.formatMessage({ id: 'alert.uploadFileList' }),
      },
    });
    try {
      if (file_xlsx) {
        Swal.fire({
          title: intl.formatMessage({ id: 'alert.confirmUpload' }),
          html: `<p class='luu-y'>${intl.formatMessage({ id: 'alert.noteCorrectTime' })}</p>`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: intl.formatMessage({ id: 'button.confirm' }),
        }).then(async (result) => {
          if (result.isConfirmed) {
            let reader = new FileReader();
            reader.onload = async (e) => {
              let data = new Uint8Array(e.target.result);
              let workbook = read(data, { type: "array" });
              let worksheet = workbook.Sheets[workbook.SheetNames[0]];
              let jsonData = utils.sheet_to_json(worksheet, { header: 1 });
              let headers = jsonData[0];

              console.log(jsonData);
              headers = [
                "releaseCode", // MÃ PHÁT HÀNH
                "promo_id", // MÃ KHUYẾN MÃI
                "code_send",
                "receiveTotal",
                "type_code", // LOẠI CODE
                "promo_code", // CODE
                "point", // ĐIỂM THƯỞNG
                "round", // VÒNG CƯỢC
                "startOf_time", // THỜI GIAN ĐẦU
                "endOf_time", //  THỜI GIAN CUỐI
                "deposite", // KIỂM TRA NẠP
                "withdraw", // KIỂM TRA RÚT
                "checkIPFP",
                "internalMess",
                "user_used", // NGƯỜI SỬ DỤNG
                "ip",
                "fp",
                "used_time", //  THỜI GIAN SỬ DỤNG
              ];
              let data_result = jsonData.slice(1).map((row) => {
                let obj = {};
                obj.depositeCount = 0;
                obj.depositeTotal = 0;
                obj.withdrawCount = 0;
                obj.withdrawTotal = 0;
                console.log(row);
                headers.forEach((header, index) => {
                  obj[header] = row[index];

                  console.log("sdafdsafdsafa" + obj[header]);

                  if (header === "code_send") {
                    let data = obj["code_send"];
                    if (data) {
                      let content = data.trim().toLowerCase();
                      if (content && content === "phone") obj["code_send"] = "phone";
                      else if (content && content === "seo") obj["code_send"] = "seo";
                      else obj["code_send"] = "free";
                    } else {
                      obj["code_send"] = "free";
                    }
                  }
                  if (header === "receiveTotal") {
                    let data = obj["receiveTotal"];
                    if (data) {
                      let content = data.trim().toLowerCase();
                      const [used, total] = content.split("|");
                      if (used && total) {
                        obj["receiveTotal"] = parseInt(total);
                        obj["receiveCount"] = parseInt(used);
                      } else {
                        obj["receiveTotal"] = 1;
                        obj["receiveCount"] = 0;
                      }
                    } else {
                      obj["receiveTotal"] = 1;
                      obj["receiveCount"] = 0;
                    }
                  }
                  if (header === "type_code") {
                    let data = obj["type_code"];
                    if (data) {
                      console.log(data);

                      let content = data.trim().toLowerCase();
                      if (content && content === "nhận 1 code") obj["type_code"] = "one_only";
                      else if (content && content === "nhận 1 code/ngày") obj["type_code"] = "one_per_day";
                      else if (content && content === "nhận 1 code/3ngày") obj["type_code"] = "one_per_3day";
                      else if (content && content === "nhận 1 code/tuần") obj["type_code"] = "one_per_week";
                      else if (content && content === "nhận 1 code/tháng") obj["type_code"] = "one_per_month";
                      else if (content && (content === "không giới hạn" || content === "")) obj["type_code"] = "no_limit";
                      else obj["type_code"] = "no_limit";
                    } else {
                      obj["type_code"] = "no_limit";
                    }
                  }
                  if (header === "promo_code") {
                    let data = obj["promo_code"];
                    obj["promo_code"] = data;
                    console.log("promo_code ádsadfds :::: " + data);
                  }
                  if (header === "deposite") {
                    let data = obj["deposite"];
                    if (data) {
                      let content = data.trim().toLowerCase();
                      if (content.indexOf("*") > -1 || content.indexOf("tất cả") > -1 || content.length === 0) {
                        obj["deposite"] = "all";
                      } else {
                        if (content.indexOf(">=") > -1) {
                          obj["deposite"] = "more_then";
                        } else if (content.indexOf("<") > -1) obj["deposite"] = "less_then";
                        else obj["deposite"] = "all";

                        const endDepositeCount = content.indexOf("(lần)");
                        const endDepositeTotal = content.indexOf("(k)");
                        obj["depositeCount"] = content.slice(
                          obj["deposite"] === "more_then" ? content.indexOf(">=") + 2 : content.indexOf("<") + 1,
                          endDepositeCount
                        );
                        obj["depositeTotal"] = content.slice(
                          obj["deposite"] === "more_then" ? content.lastIndexOf(">=") + 2 : content.lastIndexOf("<") + 1,
                          endDepositeTotal
                        );
                      }
                    } else {
                      obj["deposite"] = "all";
                    }
                  }
                  if (header === "withdraw") {
                    let data = obj["withdraw"];
                    if (data) {
                      let content = data.trim().toLowerCase();
                      if (content.indexOf("*") > -1 || content.indexOf("tất cả") > -1 || content.length === 0) {
                        obj["withdraw"] = "all";
                      } else {
                        if (content.indexOf(">=") > -1) {
                          obj["withdraw"] = "more_then";
                        } else if (content.indexOf("<") > -1) obj["withdraw"] = "less_then";
                        else obj["withdraw"] = "all";

                        const endWithdrawCount = content.indexOf("(lần)");
                        const endWithdrawTotal = content.indexOf("(k)");

                        obj["withdrawCount"] = content.slice(
                          obj["withdraw"] === "more_then" ? content.indexOf(">=") + 2 : content.indexOf("<") + 1,
                          endWithdrawCount
                        );

                        obj["withdrawTotal"] = content.slice(
                          obj["withdraw"] === "more_then" ? content.lastIndexOf(">=") + 2 : content.lastIndexOf("<") + 1,
                          endWithdrawTotal
                        );
                      }
                    } else {
                      obj["withdraw"] = "all";
                    }
                  }
                  if (header === "checkIPFP") {
                    let data = obj["checkIPFP"];
                    if (data) {
                      let content = data.trim().toLowerCase();
                      if (content === "có") obj["checkIPFP"] = "check";
                    } else {
                      obj["checkIPFP"] = "nocheck";
                    }
                  }
                  if (header === "internalMess") {
                    let data = obj["internalMess"];
                    if (data) {
                      let content = data.trim().toLowerCase();
                      if (content === "có") obj["internalMess"] = "send";
                    } else {
                      obj["internalMess"] = "nosend";
                    }
                  }
                  if (header === "user_used") {
                    let data = obj["user_used"];
                    if (data) {
                      let content = data.trim().toLowerCase();
                      if (content === "" || content === "chưa sử dụng") obj["user_used"] = "";
                    } else {
                      obj["user_used"] = "";
                    }
                  }
                  if (header === "used_time") {
                    if (obj["used_time"] === "" || !obj["used_time"]) obj["used_time"] = 0;
                  }
                  if (header === "ip") {
                    if (obj["ip"] === "" || !obj["ip"]) obj["ip"] = "";
                  }
                  if (header === "fp") {
                    if (obj["fp"] === "" || !obj["fp"]) obj["fp"] = "";
                  }
                });
                obj.createdAt = new Date().getTime();
                obj.site = localStorage.getItem("site-redeem");
                return obj;
              });
              Swal.fire({
                width: 200,
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                },
              });
              const processAndUploadData = async (data) => {
                let upload_data = data.map((elm) => {
                });
                uploadCode(upload_data);
              };
              // Gọi hàm processAndUploadData với tham số data_result
              processAndUploadData(data_result);
            };
            reader.readAsArrayBuffer(file_xlsx);
          }
        });
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: intl.formatMessage({ id: 'alert.failed' }),
        text: intl.formatMessage({ id: 'alert.uploadError' }),
      });
    }
  };
  const handelUplpadFile_code = async () => {
    let { value: file_xlsx } = await Swal.fire({
      title: intl.formatMessage({ id: 'alert.chooseFile' }),
      html: `<p class='luu-y'>${intl.formatMessage({ id: 'alert.noteCorrectFormat' })}</p> <p class='dinh-dang-time'>${intl.formatMessage({ id: 'alert.timeFormat' })} <span class='time-format'>\`yyyy/mm/dd H:mm:ss\`</span></p><p class='gio-vn'>${intl.formatMessage({ id: 'alert.vnTime' })}</p>`,
      input: "file",
      showCancelButton: true,
      cancelButtonText: intl.formatMessage({ id: 'button.cancel' }),
      confirmButtonText: intl.formatMessage({ id: 'button.uploadList' }),
      inputAttributes: {
        accept: "xlsx/xls",
        "aria-label": intl.formatMessage({ id: 'alert.uploadFileList' }),
      },
    });

    try {
      if (file_xlsx) {
        Swal.fire({
          title: intl.formatMessage({ id: 'alert.confirmUpload' }),
          html: `<p class='luu-y'>${intl.formatMessage({ id: 'alert.noteCorrectTime' })}</p>`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: intl.formatMessage({ id: 'button.confirm' }),
        }).then(async (result) => {
          if (result.isConfirmed) {
            let reader = new FileReader();
            reader.onload = async (e) => {
              let data = new Uint8Array(e.target.result);
              let workbook = read(data, { type: "array" });
              let worksheet = workbook.Sheets[workbook.SheetNames[0]];
              let jsonData = utils.sheet_to_json(worksheet, { header: 1 });
              let headers = jsonData[0];
              console.log(headers);
              headers = [
                "releaseCode", // MÃ PHÁT HÀNH
                "promo_id", // MÃ KHUYẾN MÃI
                "code_send",
                "receiveTotal",
                "type_code", // LOẠI CODE
                "promo_code", // CODE
                "point", // ĐIỂM THƯỞNG
                "round", // VÒNG CƯỢC

                "startOf_time", // THỜI GIAN ĐẦU
                "endOf_time", //  THỜI GIAN CUỐI

                "deposite", // KIỂM TRA NẠP
                "withdraw", // KIỂM TRA RÚT
                "checkIPFP",
                "internalMess",
                "user_used", // NGƯỜI SỬ DỤNG
                "ip",
                "fp",
                "used_time", //  THỜI GIAN SỬ DỤNG
              ];

              let data_result = jsonData.slice(1).map((row) => {
                console.log(row);

                let obj = {};
                obj.depositeCount = 0;
                obj.depositeTotal = 0;
                obj.withdrawCount = 0;
                obj.withdrawTotal = 0;
                obj.releaseCode = row[0];
                obj.promo_id = row[1];
                let data = row[2];
                if (typeof data === "string") {
                  console.log("type_code : " + data);
                  let content = data.trim().toLowerCase();
                  if (content && content === "nhận 1 code") obj.type_code = "one_only";
                  else if (content && content === "nhận 1 code/ngày") obj.type_code = "one_per_day";
                  else if (content && content === "nhận 1 code/3ngày") obj["type_code"] = "one_per_3day";
                  else if (content && content === "nhận 1 code/tuần") obj.type_code = "one_per_week";
                  else if (content && content === "nhận 1 code/tháng") obj.type_code = "one_per_month";
                  else if (content && (content === "không giới hạn" || content === "")) obj.type_code = "no_limit";
                  else obj.type_code = "no_limit";
                } else {
                  obj.type_code = "no_limit";
                }
                obj.promo_code = row[3];
                obj.point = row[4];
                obj.round = row[5];

                obj.startOf_time = row[6];
                if (obj.startOf_time === "" || !obj.startOf_time) obj.startOf_time = 0;

                obj.endOf_time = row[7];
                if (obj.endOf_time === "" || !obj.endOf_time) obj.endOf_time = 0;

                data = row[8] ?? null;
                if (typeof data === "string") {
                  console.log("deposite : " + data);
                  let content = data.trim().toLowerCase();
                  if (content.indexOf("*") > -1 || content.indexOf("tất cả") > -1 || content.length === 0) {
                    obj.deposite = "all";
                  } else {
                    if (content.indexOf(">=") > -1) {
                      obj.deposite = "more_then";
                    } else if (content.indexOf("<") > -1) obj.deposite = "less_then";
                    else obj.deposite = "all";

                    const endDepositeCount = content.indexOf("(lần)");
                    const endDepositeTotal = content.indexOf("(k)");
                    obj["depositeCount"] = content.slice(
                      obj.deposite === "more_then" ? content.indexOf(">=") + 2 : content.indexOf("<") + 1,
                      endDepositeCount
                    );
                    obj["depositeTotal"] = content.slice(
                      obj.deposite === "more_then" ? content.lastIndexOf(">=") + 2 : content.lastIndexOf("<") + 1,
                      endDepositeTotal
                    );
                  }
                }
                data = row[9] ?? null;
                if (typeof data === "string") {
                  console.log("withdraw : " + data);

                  let content = data.trim().toLowerCase();
                  if (content.indexOf("*") > -1 || content.indexOf("tất cả") > -1 || content.length === 0) {
                    obj.withdraw = "all";
                  } else {
                    if (content.indexOf(">=") > -1) {
                      obj.withdraw = "more_then";
                    } else if (content.indexOf("<") > -1) obj.withdraw = "less_then";
                    else obj.withdraw = "all";

                    const endWithdrawCount = content.indexOf("(lần)");
                    const endWithdrawTotal = content.indexOf("(k)");

                    obj["withdrawCount"] = content.slice(
                      obj.withdraw === "more_then" ? content.indexOf(">=") + 2 : content.indexOf("<") + 1,
                      endWithdrawCount
                    );

                    obj["withdrawTotal"] = content.slice(
                      obj.withdraw === "more_then" ? content.lastIndexOf(">=") + 2 : content.lastIndexOf("<") + 1,
                      endWithdrawTotal
                    );
                  }
                } else {
                  obj.withdraw = "all";
                }
                data = row[10] ?? null;
                if (typeof data === "string") {
                  let content = data.trim().toLowerCase();
                  if (content === "có") obj.checkIPFP = "check";
                } else {
                  obj.checkIPFP = "nocheck";
                }

                let content = row[11];
                (content === "" || content === "chưa sử dụng") ? obj.user_used = "" : obj.user_used = content;

                obj.ip = row[12];
                if (obj.ip === "" || !obj.ip) obj.ip = "";

                obj.fp = row[13];
                if (obj.fp === "" || !obj.fp) obj.fp = "";

                obj.used_time = row[14];
                if (obj.used_time === "" || !obj.used_time) obj.used_time = 0;

                obj.createdAt = new Date().getTime();
                obj.site = localStorage.getItem("site-redeem");
                return obj;
              });

              Swal.fire({
                width: 200,
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                },
              });

              const processAndUploadData = async (data) => {
                let upload_data = data.map((elm) => {
                  if (elm.releaseCode) {
                    if (elm.startOf_time) {
                      if (parseInt(elm.startOf_time) === parseInt(moment().format("YYYY")))
                        elm.startOf_time = new Date(elm.startOf_time).getTime() - 60 * 60000;
                      else elm.startOf_time = new Date((elm.startOf_time - 25569) * 86400000 - 420 * 60000).getTime();
                    }
                    if (elm.endOf_time) {
                      if (parseInt(elm.endOf_time) === parseInt(moment().format("YYYY")))
                        elm.endOf_time = new Date(elm.endOf_time).getTime() - 60 * 60000;
                      else elm.endOf_time = new Date((elm.endOf_time - 25569) * 86400000 - 420 * 60000).getTime();
                    }
                    if (elm.used_time) {
                      if (parseInt(elm.used_time) === parseInt(moment().format("YYYY")))
                        elm.used_time = new Date(elm.used_time).getTime() - 60 * 60000;
                      else elm.used_time = new Date((elm.used_time - 25569) * 86400000 - 420 * 60000).getTime();
                    }
                    if (elm.promo_code) {
                      elm.promo_code = elm.promo_code.toString();
                    }
                    elm.releaseCode = elm.releaseCode.toString();
                    return elm;
                  }
                  return elm;
                });
                uploadCode(upload_data);
              };
              // Gọi hàm processAndUploadData với tham số data_result
              processAndUploadData(data_result);
            };
            reader.readAsArrayBuffer(file_xlsx);
          }
        });
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: intl.formatMessage({ id: 'alert.failed' }),
        text: intl.formatMessage({ id: 'alert.uploadError' }),
      });
    }
  };

  const handelDelete_code = () => {
    Swal.fire({
      text: intl.formatMessage({ id: 'alert.checkingData' }),
      width: 250,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    let find_endOf_time_tmp = 0;
    if (find_endOf_time) {
      find_endOf_time_tmp = new Date(find_endOf_time).getTime() - new Date().getTimezoneOffset() * 60000 - 420 * 60000;
    }
    deleteCode(find_endOf_time_tmp, find_status?.value, find_promo_code, find_releaseCode, find_promo_id, find_user_used, find_ip);
  };

  return (
    <>
      <Sidebar setNavstate={setNavstate} navstate={navstate} />
      <Box id="main" className={navstate ? "" : "main-wide"}>
        <Header
          setNavstate={setNavstate}
          navstate={navstate}
          title={intl.formatMessage({ id: role_superadmin ? 'page.generateCode' : 'page.manageCode' })}
        />
        {role_superadmin && (
          <Box className="status-transfer">
            <Box className="card-status-transfer">
              <Box className="item-status-transfer">
                <Box className="body-item-status-transfer">
                  <span className="title-item-status-transfer">
                    {intl.formatMessage({ id: 'stats.usedCodes' })}
                  </span>
                  <Box className="num-cont-item-status-transfer">
                    <span id="count-bill" className="amount-item"></span>
                    <span className="amount-item unit-item">code</span>
                  </Box>
                  <Box className="color-animation"></Box>
                </Box>
              </Box>
            </Box>

            <Box className="card-status-transfer">
              <Box className="item-status-transfer">
                <Box className="body-item-status-transfer">
                  <span className="title-item-status-transfer">{intl.formatMessage({ id: 'stats.issuedMoney' })}</span>
                  <Box className="num-cont-item-status-transfer">
                    <span id="amount-currency" className="amount-item"></span>
                    <span className="amount-item unit-item">VNĐ</span>
                  </Box>
                  <Box className="color-animation"></Box>
                </Box>
              </Box>
            </Box>
            <Box className="card-status-transfer last-card">
              <Box className="item-status-transfer">
                <Box className="body-item-status-transfer">
                  <p className="title-item-status-transfer">{intl.formatMessage({ id: 'stats.createdCodes' })}</p>
                  <Box className="num-cont-item-status-transfer">
                    <p id="balance" className="amount-item"></p>
                    <p className="amount-item unit-item">code</p>
                  </Box>
                  <Box className="color-animation"></Box>
                </Box>
              </Box>
            </Box>
            <Box className="card-status-transfer last-card">
              <Box className="item-status-transfer">
                <Box className="body-item-status-transfer">
                  <p className="title-item-status-transfer">{intl.formatMessage({ id: 'stats.fakeCodes' })}</p>
                  <Box className="num-cont-item-status-transfer">
                    <p id="code_fake" className="amount-item"></p>
                    <p className="amount-item unit-item">code</p>
                  </Box>
                  <Box className="color-animation"></Box>
                </Box>
              </Box>
            </Box>
          </Box>
        )}
        {role_superadmin && (
          <Box className="input-form-cont">
            <Box sx={{ display: "flex", justifyContent: "space-between", pb: 2 }}>
              <Box sx={{ display: "flex" }}>
                <Box sx={{ mt: 1 }} className="mark"></Box>
                <Typography className="typo-white-mui" variant="h6" sx={{ pr: 4, mt: 1 }}>
                  {intl.formatMessage({ id: 'form.createCode' })}
                </Typography>
              </Box>
            </Box>
            <Box>
              <Box className="input-form-wrapper">
                {/* Hạn sử dụng */}
                <Box className="date-input">
                  <Typography
                    sx={{
                      fontweight: 400,
                      transformOrigin: "top left",
                      transform: "translate(0, -1.5px) scale(0.75)",
                      position: "absolute",
                      color: "#414141",
                      ml: 1,
                    }}
                  >
                    {intl.formatMessage({ id: 'form.usageTime' })} (GMT+7)
                  </Typography>
                  <Box sx={{ margin: 1 }} className="date-input">
                    <DateTimePicker
                      className="date-picker-customer"
                      id="startOf_time"
                      onChange={setStartOf_time}
                      value={startOf_time}
                      variant="standard"
                    />
                    <DateTimePicker className="date-picker-customer" id="endOf_time" onChange={setEndOf_time} value={endOf_time} variant="standard" />
                  </Box>
                </Box>
                {/* Mã phát hành */}
                <TextField
                  sx={{ margin: 1, width: 150, fontSize: "12px" }}
                  id="id"
                  label={intl.formatMessage({ id: 'form.releaseCode' })}
                  title={intl.formatMessage({ id: 'form.releaseCode' })}
                  size="small"
                  variant="standard"
                  value={releaseCode}
                  onChange={(event) => setReleaseCode(event.target.value)}
                />
                {/* Mã khuyến mãi */}
                <TextField
                  sx={{ margin: 1, width: 150, fontSize: "12px" }}
                  id="promo-id"
                  label={intl.formatMessage({ id: 'form.promoCode' })}
                  title={intl.formatMessage({ id: 'form.promoCode' })}
                  size="small"
                  variant="standard"
                  value={promo_id}
                  onChange={(event) => setPromo_id(event.target.value)}
                />
                {/* Số lượng code */}
                <TextField
                  type="number"
                  sx={{ width: 150, margin: 1, fontSize: "12px" }}
                  id="list-code-length"
                  label={intl.formatMessage({ id: 'form.codeQuantity' })}
                  title={intl.formatMessage({ id: 'form.codeQuantity' })}
                  size="small"
                  variant="standard"
                  value={countCode}
                  onChange={(event) => (setCountCode(parseInt(event.target.value)))}
                  onBlur={(event) => (event.target.value < 1 ? setCountCode(1) : setCountCode(parseInt(event.target.value)))}
                />
                {/* Độ dài code */}
                <TextField
                  type="number"
                  sx={{ width: 150, margin: 1, fontSize: "12px" }}
                  id="code-length"
                  label={intl.formatMessage({ id: 'form.codeLength' })}
                  title={intl.formatMessage({ id: 'form.codeLength' })}
                  size="small"
                  variant="standard"
                  value={lengthCode}
                  onChange={(event) => (setLengthCode(parseInt(event.target.value)))}
                  onBlur={(event) => (event.target.value < 1 ? setLengthCode(1) : setLengthCode(parseInt(event.target.value)))}
                />
                {/* Vòng cược */}
                <TextField
                  type="number"
                  sx={{ width: 150, margin: 1, fontSize: "12px" }}
                  id="round"
                  label={intl.formatMessage({ id: 'form.round' })}
                  title={intl.formatMessage({ id: 'form.round' })}
                  size="small"
                  variant="standard"
                  value={round}
                  onChange={(event) => (setRound(parseInt(event.target.value)))}
                  onBlur={(event) => (event.target.value < 1 ? setRound(1) : setRound(parseInt(event.target.value)))}
                />
                {/* Loại mã KM */}
                <Autocomplete
                  sx={{ width: 200, margin: 1, fontSize: "12px" }}
                  disablePortal
                  id="type_code"
                  options={arrTypeMKM}
                  value={type_code}
                  onChange={(event, value) => {
                    setType_code(value);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={intl.formatMessage({ id: 'form.codeType' })} size="small" title={intl.formatMessage({ id: 'form.codeType' })} variant="standard" />
                  )}
                />
                {/* Điểm thưởng */}
                <Box sx={{ display: "flex", width: "fit-content", margin: 1, fontSize: "12px" }}>
                  <Autocomplete
                    sx={{ width: 150 }}
                    options={arrTypePoint}
                    id="disable-close-on-select"
                    defaultValue={arrTypePoint[0]}
                    disableClearable
                    renderInput={(params) => <TextField sx={{ width: "100%" }} {...params} label={intl.formatMessage({ id: 'form.rewardPoints' })} variant="standard" />}
                    title={intl.formatMessage({ id: 'form.rewardPoints' })}
                    size="small"
                    value={typePoint}
                    onChange={(event, item) => {
                      setTypePoint(item);
                    }}
                  />
                  {typePoint?.value === "number_static" && (
                    <Box sx={{ display: "flex", ml: 1, mr: 1 }}>
                      <Typography
                        sx={{
                          fontweight: 400,
                          transformOrigin: "top left",
                          transform: "translate(0, -1.5px) scale(0.75)",
                          position: "absolute",
                          color: "#414141",
                        }}
                      >
                        {intl.formatMessage({ id: 'form.points' })}
                      </Typography>
                      <Input
                        sx={{ width: 100, margin: "auto", mt: "13px", pl: 1 }}
                        type="number"
                        label={intl.formatMessage({ id: 'form.points' })}
                        variant="standard"
                        value={staticPoint}
                        slotProps={{
                          input: {
                            min: 1,
                            max: 500,
                            step: 1,
                          },
                        }}
                        onChange={(event) => (setStaticPoint(parseInt(event.target.value)))}
                        onBlur={(event) => (event.target.value < 1 ? setStaticPoint(1) : setStaticPoint(parseInt(event.target.value)))}
                      />
                    </Box>
                  )}
                  {(typePoint?.value === "number_range" || typePoint?.value === "number_or") && (
                    <Box sx={{ display: "flex" }}>
                      <Box sx={{ display: "flex", ml: 1, mr: 1 }}>
                        <Typography
                          sx={{
                            fontweight: 400,
                            transformOrigin: "top left",
                            transform: "translate(0, -1.5px) scale(0.75)",
                            position: "absolute",
                            color: "#414141",
                          }}
                        >
                          {intl.formatMessage({ id: 'form.from' })}
                        </Typography>
                        <Input
                          sx={{ width: 50, margin: "auto", mt: "13px", pl: 1 }}
                          type="number"
                          label={intl.formatMessage({ id: 'form.from' })}
                          variant="standard"
                          value={startOfPoint}
                          slotProps={{
                            input: {
                              min: 1,
                              max: 500,
                              step: 1,
                            },
                          }}
                          onChange={(event) => (setStartOfPoint(parseInt(event.target.value)))}
                          onBlur={(event) => (event.target.value < 1 ? setStartOfPoint(1) : setStartOfPoint(parseInt(event.target.value)))}
                        />
                      </Box>
                      <Box sx={{ display: "flex", ml: 1, mr: 1 }}>
                        <Typography
                          sx={{
                            fontweight: 400,
                            transformOrigin: "top left",
                            transform: "translate(0, -1.5px) scale(0.75)",
                            position: "absolute",
                            color: "#414141",
                          }}
                        >
                          {intl.formatMessage({ id: 'form.to' })}
                        </Typography>
                        <Input
                          sx={{ width: 50, margin: "auto", mt: "13px", pl: 1 }}
                          type="number"
                          label={intl.formatMessage({ id: 'form.to' })}
                          variant="standard"
                          value={endOfPoint}
                          slotProps={{
                            input: {
                              min: 1,
                              max: 500,
                              step: 1,
                            },
                          }}
                          onChange={(event) => (setEndOfPoint(parseInt(event.target.value)))}
                          onBlur={(event) => (event.target.value < 1 ? setEndOfPoint(1) : setEndOfPoint(parseInt(event.target.value)))}
                        />
                      </Box>
                    </Box>
                  )}
                  <TextField
                    sx={{ width: 50 }}
                    type="number"
                    id="fixed"
                    label={intl.formatMessage({ id: 'form.decimalPoints' })}
                    title={intl.formatMessage({ id: 'form.decimalPoints' })}
                    size="small"
                    variant="standard"
                    value={fixed}
                    inputProps={{
                      min: 0.0,
                      max: 0.99,
                      step: 0.01,
                    }}
                    onChange={(event) => setFixed(parseFloat(event.target.value % 100).toFixed(2))}
                  />
                </Box>
                {/* Lần nhận code */}
                {showmore && (
                  <TextField
                    type="number"
                    sx={{ width: 150, margin: 1, fontSize: "12px" }}
                    id="receive-total"
                    label={intl.formatMessage({ id: 'form.receiveTimes' })}
                    title={intl.formatMessage({ id: 'form.receiveTimes' })}
                    size="small"
                    variant="standard"
                    value={receiveTotal}
                    onChange={(event) => (setReceiveTotal(parseInt(event.target.value)))}
                    onBlur={(event) => (event.target.value < 1 ? setReceiveTotal(1) : setReceiveTotal(parseInt(event.target.value)))}
                  />
                )}
                {/* Nạp tiền */}
                {showmore && (
                  <>
                    {" "}
                    <Autocomplete
                      sx={{ width: 150, margin: 1, fontSize: "12px" }}
                      disablePortal
                      disableClearable
                      disabledItemsFocusable
                      freeSolo={false}
                      id="deposite"
                      options={arrDepositeV2}
                      value={deposite}
                      onChange={(event, value) => {
                        setDeposite(value);
                      }}
                      renderInput={(params) => <TextField {...params} label={intl.formatMessage({ id: 'form.deposit' })} size="small" title={intl.formatMessage({ id: 'form.deposit' })} variant="standard" />}
                    />
                    {(deposite?.value === "more_then" || deposite?.value === "less_then") && (
                      <TextField
                        type="number"
                        sx={{ width: 150, margin: 1, fontSize: "12px" }}
                        id="depositeCount"
                        label={intl.formatMessage({ id: 'form.times' })}
                        title={intl.formatMessage({ id: 'form.times' })}
                        size="small"
                        variant="standard"
                        value={depositeCount}
                        onChange={(event) => (event.target.value < 0 ? setDepositeCount(0) : setDepositeCount(parseInt(event.target.value)))}
                      />
                    )}
                    {(deposite?.value === "more_then" || deposite?.value === "less_then") && (
                      <TextField
                        type="number"
                        sx={{ width: 150, margin: 1, fontSize: "12px" }}
                        id="depositeTotal"
                        label={intl.formatMessage({ id: 'form.total' })}
                        title={intl.formatMessage({ id: 'form.total' })}
                        size="small"
                        variant="standard"
                        value={depositeTotal}
                        onChange={(event) => (event.target.value < 0 ? setDepositeTotal(0) : setDepositeTotal(parseInt(event.target.value)))}
                      />
                    )}
                  </>
                )}
                {/* Rút tiền */}
                {showmore && (
                  <>
                    <Autocomplete
                      sx={{ width: 150, margin: 1, fontSize: "12px" }}
                      disablePortal
                      disableClearable
                      disabledItemsFocusable
                      freeSolo={false}
                      id="withdraw"
                      options={arrWithdrawV2}
                      value={withdraw}
                      onChange={(event, value) => {
                        setWithdraw(value);
                      }}
                      renderInput={(params) => <TextField {...params} label={intl.formatMessage({ id: 'form.withdraw' })} size="small" title={intl.formatMessage({ id: 'form.withdraw' })} variant="standard" />}
                    />
                    {(withdraw?.value === "more_then" || withdraw?.value === "less_then") && (
                      <TextField
                        type="number"
                        sx={{ width: 150, margin: 1, fontSize: "12px" }}
                        id="withdrawCount"
                        label={intl.formatMessage({ id: 'form.times' })}
                        title={intl.formatMessage({ id: 'form.times' })}
                        size="small"
                        variant="standard"
                        value={withdrawCount}
                        onChange={(event) => (event.target.value < 0 ? setWithdrawCount(0) : setWithdrawCount(parseInt(event.target.value)))}
                      />
                    )}
                    {(withdraw?.value === "more_then" || withdraw?.value === "less_then") && (
                      <TextField
                        type="number"
                        sx={{ width: 150, margin: 1, fontSize: "12px" }}
                        id="withdrawTotal"
                        label={intl.formatMessage({ id: 'form.total' })}
                        title={intl.formatMessage({ id: 'form.total' })}
                        size="small"
                        variant="standard"
                        value={withdrawTotal}
                        onChange={(event) => (event.target.value < 0 ? setWithdrawTotal(0) : setWithdrawTotal(parseInt(event.target.value)))}
                      />
                    )}
                  </>
                )}
                {/* Trạng thái */}
                {showmore && (
                  <>
                    <Autocomplete
                      disablePortal
                      id="used_code"
                      options={arrUsedMKM}
                      sx={{ width: 150, margin: 1, fontSize: "12px" }}
                      onChange={(event, value) => {
                        setUsed_code(value);
                        console.log(value);
                      }}
                      value={used_code}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={intl.formatMessage({ id: 'form.status' })}
                          size="small"
                          title={intl.formatMessage({ id: 'form.status' })}
                          variant="standard"
                        />
                      )}
                    />
                    {used_code?.value === "code_used" && (
                      <Box sx={{ margin: "5px" }} className="date-input">
                        <DateTimePicker className="date-picker-customer" id="used_time" onChange={setUsed_time} value={used_time} />
                      </Box>
                    )}
                  </>
                )}
                {/* Random ký tự */}
                {showmore && (
                  <Autocomplete
                    sx={{ width: 150, margin: 1, fontSize: "12px" }}
                    disablePortal
                    disableClearable
                    disabledItemsFocusable
                    freeSolo={false}
                    id="randomchar"
                    options={arrTypeChar}
                    value={typeChar}
                    onChange={(event, value) => {
                      setTypeChar(value);
                    }}
                    renderInput={(params) => <TextField {...params} label={intl.formatMessage({ id: 'form.randomChar' })} size="small" title={intl.formatMessage({ id: 'form.randomChar' })} variant="standard" />}
                  />
                )}
                {/* Check trùng IP-FP */}
                {showmore && (
                  <Autocomplete
                    sx={{ width: 150, margin: 1, fontSize: "12px" }}
                    disablePortal
                    disableClearable
                    disabledItemsFocusable
                    freeSolo={false}
                    id="checkipfp"
                    options={arrCheckIPFP}
                    value={checkIPFP}
                    onChange={(event, value) => {
                      setCheckIPFP(value);
                    }}
                    renderInput={(params) => <TextField {...params} label={intl.formatMessage({ id: 'form.checkIPFP' })} size="small" title={intl.formatMessage({ id: 'form.checkIPFP' })} variant="standard" />}
                  />
                )}
                {/* Gửi thư nội bộ */}

                {showmore && (
                  <Autocomplete
                    sx={{ width: 150, margin: 1, fontSize: "12px" }}
                    disablePortal
                    disableClearable
                    disabledItemsFocusable
                    freeSolo={false}
                    id="internalmess"
                    options={arrInternalMess}
                    value={internalMess}
                    onChange={(event, value) => {
                      setInternalMess(value);
                    }}
                    renderInput={(params) => <TextField {...params} label={intl.formatMessage({ id: 'form.internalMessage' })} size="small" title={intl.formatMessage({ id: 'form.internalMessage' })} variant="standard" />}
                  />
                )}
                {/* Tạo mã QR */}
                {showmore && (
                  <Autocomplete
                    sx={{ width: 150, margin: 1, fontSize: "12px" }}
                    disablePortal
                    disableClearable
                    disabledItemsFocusable
                    freeSolo={false}
                    id="generate-qr"
                    options={arrGenerateQr}
                    value={generateQr}
                    onChange={(event, value) => {
                      setGenerateQr(value);
                    }}
                    renderInput={(params) => <TextField {...params} label={intl.formatMessage({ id: 'form.generateQR' })} size="small" title={intl.formatMessage({ id: 'form.generateQR' })} variant="standard" />}
                  />
                )}
                {/* Loại code SEO/FREE/PHONE */}
                {showmore && (
                  <Autocomplete
                    sx={{ width: 200, margin: 1, fontSize: "12px" }}
                    disablePortal
                    disableClearable
                    disabledItemsFocusable
                    freeSolo={false}
                    id="codeSeo"
                    options={arrCode_send}
                    value={code_send}
                    onChange={(event, value) => {
                      setCode_send(value);
                    }}
                    renderInput={(params) => <TextField {...params} label={intl.formatMessage({ id: 'form.codeType' })} size="small" title={intl.formatMessage({ id: 'form.codeType' })} variant="standard" />}
                  />
                )}
              </Box>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", position: "relative" }}>
              <Button
                sx={{
                  p: 1,
                  m: 1,
                  color: "#fff",
                  background: "#9f9f9f",
                  ":hover": {
                    background: "#595959",
                  },
                }}
                onClick={reset_Download}
                variant="text"
                size="small"
              >
                {intl.formatMessage({ id: 'button.reset' })}
              </Button>
              <Button sx={{ p: 1, m: 1 }} onClick={Generate_Download} startIcon={<Shuffle />} variant="contained" size="small">
                {intl.formatMessage({ id: 'button.generate' })}
              </Button>
              <Box sx={{ position: "absolute", bottom: 0, right: 0, padding: 1 }}>
                {!showmore && (
                  <Button startIcon={<ArrowDropDown />} onClick={() => setShowmore(!showmore)}>
                    {intl.formatMessage({ id: 'button.showMore' })}
                  </Button>
                )}
                {showmore && (
                  <Button startIcon={<ArrowDropUp />} onClick={() => setShowmore(!showmore)}>
                    {intl.formatMessage({ id: 'button.showLess' })}
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        )}
        <Box className="find-code-cont">
          <Box sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", borderColor: "divider" }}>
            <Box sx={{ display: "flex" }}>
              <Box sx={{ mt: 1 }} className="mark"></Box>
              <Typography className="typo-white-mui" variant="h6" sx={{ pr: 4, mt: 1 }}>
                {role_superadmin ? intl.formatMessage({ id: 'page.manageCode' }) : intl.formatMessage({ id: 'page.checkCode' })}
              </Typography>
            </Box>
            <Box sx={{ display: "flex" }}>
              {role_superadmin && (
                <Button
                  onClick={handelUplpadFile_code}
                  id="upload-btn"
                  size="small"
                  variant="outlined"
                  sx={{
                    m: "8px 8px 0 8px",
                  }}
                >
                  {intl.formatMessage({ id: 'button.uploadFile' })}
                </Button>
              )}
              {role_superadmin && (
                <a href={example} download="example_code.xlsx">
                  <Button
                    id="file-example-btn"
                    size="small"
                    variant="outlined"
                    sx={{
                      m: "8px 8px 0 8px",
                    }}
                  >
                    {intl.formatMessage({ id: 'button.downloadExample' })}
                  </Button>
                </a>
              )}
              {role_superadmin && (
                <LoadingButton
                  sx={{
                    m: "8px 8px 0 8px",
                  }}
                  onClick={handelExport_code}
                  loading={exporting}
                  loadingPosition="start"
                  startIcon={<FileDownload />}
                  variant="outlined"
                  size="small"
                >
                  {intl.formatMessage({ id: 'button.exportExcel' })}
                </LoadingButton>
              )}
              {role_superadmin && (
                <Button
                  onClick={handelDelete_code}
                  id="upload-btn"
                  size="small"
                  variant="outlined"
                  sx={{
                    m: "8px 8px 0 8px",
                    background: "#f00",
                  }}
                >
                  {intl.formatMessage({ id: 'button.deleteCode' })}
                </Button>
              )}
              <Button
                size="small"
                onClick={handelFind_code_paging}
                variant="outlined"
                sx={{
                  m: "8px 8px 0 8px",
                }}
              >
                {intl.formatMessage({ id: 'button.search' })}
              </Button>
            </Box>
          </Box>
          <Box sx={{ width: "100%", paddingTop: "10px" }}>
            <Box sx={{ display: "flex" }}>
              <Box sx={{ margin: "5px" }} className="date-input">
                <Box sx={{ margin: "5px" }} className="date-input">
                  <DateTimePicker
                    className="date-picker-customer"
                    id="endOf_time"
                    onChange={setFind_endOf_time}
                    value={find_endOf_time}
                    variant="standard"
                  />
                  <p className="exp-code-descript">{intl.formatMessage({ id: 'form.codeExpiry' })} GMT+7</p>
                </Box>
              </Box>
              <Autocomplete
                sx={{ margin: 1, width: 100 }}
                options={arrTypePromocode}
                id="disable-close-on-select"
                disableClearable
                renderInput={(params) => <TextField {...params} label={intl.formatMessage({ id: 'form.search' })} variant="standard" helperText="* Áp dụng" />}
                title={intl.formatMessage({ id: 'form.search' })}
                size="small"
                value={find_typePromo_code}
                onChange={(event, item) => {
                  setFind_typePromo_code(item);
                }}
              />
              <TextField
                sx={{ margin: "5px" }}
                id="find-code"
                label={intl.formatMessage({ id: 'form.code' })}
                title={intl.formatMessage({ id: 'form.code' })}
                size="small"
                variant="standard"
                value={find_promo_code}
                onChange={(event) => setFind_promo_code(event.target.value)}
              />
              {role_superadmin && (
                <TextField
                  sx={{ margin: "5px" }}
                  id="find-id"
                  label={intl.formatMessage({ id: 'form.releaseCode' })}
                  title={intl.formatMessage({ id: 'form.releaseCode' })}
                  size="small"
                  variant="standard"
                  value={find_releaseCode}
                  onChange={(event) => setFind_releaseCode(event.target.value)}
                />
              )}
              {role_superadmin && (
                <TextField
                  sx={{ margin: "5px" }}
                  id="find-promo-id"
                  label={intl.formatMessage({ id: 'form.promoCode' })}
                  title={intl.formatMessage({ id: 'form.promoCode' })}
                  size="small"
                  variant="standard"
                  value={find_promo_id}
                  onChange={(event) => setFind_promo_id(event.target.value)}
                />
              )}
              <TextField
                sx={{ margin: 1, width: 180 }}
                id="find-user-used"
                label={intl.formatMessage({ id: 'form.playerID' })}
                title={intl.formatMessage({ id: 'form.playerID' })}
                size="small"
                variant="standard"
                value={find_user_used}
                onChange={(event) => setFind_user_used(event.target.value)}
              />
              {role_superadmin && (
                <TextField
                  sx={{ margin: 1, width: 150 }}
                  id="find-ip"
                  label={intl.formatMessage({ id: 'form.ipAddress' })}
                  title={intl.formatMessage({ id: 'form.ipAddress' })}
                  size="small"
                  variant="standard"
                  value={find_ip}
                  onChange={(event) => setFind_ip(event.target.value)}
                />
              )}
              {role_superadmin && (
                <Autocomplete
                  sx={{ margin: 1, width: 150 }}
                  options={arrStatusCode}
                  id="disable-close-on-select"
                  disableClearable
                  renderInput={(params) => <TextField {...params} label={intl.formatMessage({ id: 'form.status' })} variant="standard" />}
                  title={intl.formatMessage({ id: 'form.status' })}
                  size="small"
                  value={find_status}
                  onChange={(event, item) => {
                    setFind_status(item);
                  }}
                />
              )}
              {role_superadmin && (
                <Autocomplete
                  sx={{ margin: 1, width: 150 }}
                  options={find_arrCode_send}
                  id="disable-close-on-select"
                  disableClearable
                  renderInput={(params) => <TextField {...params} label={intl.formatMessage({ id: 'form.codeType' })} variant="standard" />}
                  title={intl.formatMessage({ id: 'form.codeType' })}
                  size="small"
                  value={find_code_send}
                  onChange={(event, item) => {
                    setFind_code_send(item);
                  }}
                />
              )}
            </Box>
            <Box sx={{ marginTop: "10px" }}>
              <TableCodes rows={rows} />
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <TablePagination
                  rowsPerPageOptions={[50, 100, 250, 500]}
                  component="div"
                  colSpan={5}
                  count={total}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      "aria-label": "Số hàng mỗi trang",
                    },
                    native: true,
                  }}
                  labelDisplayedRows={({ from, to, count }) => {
                    return `${from} - ${to}  Tổng (${count})`;
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                  labelRowsPerPage={intl.formatMessage({ id: 'form.rowsPerPage' })}
                  sx={{ borderBottom: "none" }}
                />
                <Box sx={{ textAlign: "start", fontSize: "12px", marginY: "auto", paddingRight: 2 }}>
                  <Box>{rows?.length > 0 ? rows?.length : 0} (Đơn)</Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default GenerateCode;

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, parseInt(page) + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  const handleButtonClick = (event) => {
    onPageChange(event, parseInt(event.target.innerText) - 1);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      {page > 2 && (
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
          {theme.direction === "rtl" ? <LastPage /> : <FirstPage />}
        </IconButton>
      )}
      {page > 1 && (
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
          {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
      )}
      {page > 0 && (
        <Button
          onClick={handleButtonClick}
          aria-label="page"
          sx={{ padding: 0, margin: 0, minWidth: "30px", borderRadius: "unset", fontSize: "14px", color: "black" }}
        >
          {parseInt(page)}
        </Button>
      )}
      <Button
        aria-label="page"
        sx={{
          padding: 0,
          margin: 0,
          minWidth: "30px",
          borderRadius: "unset",
          fontSize: "18px",
          fontWeight: "bold",
          color: "white",
          background: "#06ff49",
        }}
      >
        {page + 1}
      </Button>
      {page > -1 && Math.ceil(count / rowsPerPage) - 1 > page && (
        <Button
          onClick={handleButtonClick}
          aria-label="page"
          sx={{ padding: 0, margin: 0, minWidth: "30px", borderRadius: "unset", fontSize: "14px", color: "black" }}
        >
          {parseInt(page) + 2}
        </Button>
      )}
      {page > -1 && Math.ceil(count / rowsPerPage) - 2 > page && (
        <Button
          onClick={handleButtonClick}
          aria-label="page"
          sx={{ padding: 0, margin: 0, minWidth: "30px", borderRadius: "unset", fontSize: "14px", color: "black" }}
        >
          {parseInt(page) + 3}
        </Button>
      )}
      {page > -1 && Math.ceil(count / rowsPerPage) - 1 > page && (
        <IconButton onClick={handleNextButtonClick} disabled={count === 0 || count < rowsPerPage} aria-label="next page">
          {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
      )}
      {page > -1 && Math.ceil(count / rowsPerPage) - 2 > page && (
        <IconButton onClick={handleLastPageButtonClick} disabled={Math.ceil(count / rowsPerPage) - 2 < 0} aria-label="last page">
          {theme.direction === "rtl" ? <FirstPage /> : <LastPage />}
        </IconButton>
      )}
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};
